'use client'

import { Suspense, useState } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'

import FeatureCreators, {
  FeatureCreatorsSkeleton,
} from '@/app/[locale]/(worlds)/components/FeatureCreators'
import type { Creator } from '@/services/cms'

type FeatureCreatorsLazyProps = {
  creatorsPromise: Promise<Creator[]>
}

export default function FeatureCreatorsLazy({ creatorsPromise }: FeatureCreatorsLazyProps) {
  const [shouldRender, setShouldRender] = useState(false)

  const { ref } = useIntersectionObserver({
    threshold: 0,
    rootMargin: '600px 0px',
    freezeOnceVisible: true,
    onChange: (isIntersecting) => {
      if (!isIntersecting) return

      setShouldRender(true)
    },
  })

  if (!shouldRender) {
    return <div ref={ref} className="min-h-[148px]" aria-hidden />
  }

  return (
    <Suspense fallback={<FeatureCreatorsSkeleton sectionClassName="gap-2" />}>
      <FeatureCreators creatorsPromise={creatorsPromise} sectionClassName="gap-2" />
    </Suspense>
  )
}
